<template>
  <a-select
      mode="multiple"
      v-bind="instance"
      style="width: 100%"
      :value="defaultValue"
      @change="handleChange"
      :getPopupContainer="triggerNode => triggerNode.parentNode"
    >
      <a-select-option v-for="i in instance.list" :key="i.value">
        {{ i.label }}
      </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: 'NewAMultipleSelect',
  props: {
    instance: Object
  },
  data() {
    return {
      defaultValue: []
    }
  },
  mounted() {
  },
  watch: {
    instance: {
      handler(nVal) {
        Object.assign(this, { ...nVal }) // 把传入的参数，融合到this中
        // console.log(this.defaultValue , 'select')
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>

<style>

</style>